import { useIsOnCartPage } from "@faire/deprecated-retailer-visitor-shared/hooks/cart/useIsOnCartPage";
import { useQuery as useFaireSourceEligibilityQuery } from "@faire/web-api--source/endpoints/www/api/retailers/fulfilled-by-faire-benefits-eligibility/get-hooks";
import { IGetFulfilledByFaireBenefitsEligibilityResponse } from "@faire/web-api--source/faire/retailers/retailers_service/IGetFulfilledByFaireBenefitsEligibilityResponse";

type Args = {
  initialData: IGetFulfilledByFaireBenefitsEligibilityResponse;
};

export const useFaireSourceEligibility = (args?: Args) => {
  const isOnCartPage = useIsOnCartPage();
  const { data } = useFaireSourceEligibilityQuery({
    refetchOnMount: false,
    enabled: isOnCartPage,
    initialData: args?.initialData,
  });
  return Boolean(data?.is_eligible);
};
